import React, { useContext, useEffect, useState } from "react";
import style from "./index.module.scss";
import { Checkbox } from "antd";
import {
    findMoreValue,
    OptionItem,
    TopicsItem
} from "../../../../../../../API/exercise";
import { ExerciseContext } from "../../../../../Store";

interface PageCheckBoxProps {
    index?: number;
    data: TopicsItem;
    moreSave: (questionId: string, value: any) => void;
}

export default function PageCheckBox({
    data,
    moreSave,
    index
}: PageCheckBoxProps) {
    const [selectVal, setSelectVal] = useState<any>([]);
    const { exercise } = useContext(ExerciseContext);

    useEffect(() => {
        let val = findMoreValue(data.id, exercise);
        setSelectVal(val);
    }, [data, exercise]);

    function onChange(val: any) {
        setSelectVal(val);
        moreSave(data.id, val);
    }

    return (
        <div className={style.root}>
            <div>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（多选题，{data.score}分）</span>
            </div>
            <div className={style.title}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: data.contentText
                    }}
                />
            </div>
            <div className={style.options}>
                <Checkbox.Group
                    value={selectVal}
                    onChange={val => onChange(val)}>
                    {data.options &&
                        data.options.map((item: OptionItem, index: number) => (
                            <Checkbox value={item.id} key={index}>
                                <span className={style.letter}>
                                    {String.fromCharCode(65 + index)}.
                                </span>
                                <span
                                    className={style.spanHtml}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </Checkbox>
                        ))}
                </Checkbox.Group>
            </div>
        </div>
    );
}
